// modules
import { createAction } from 'redux-actions'

// actions
export const setPatientList = createAction('SET_PATIENT_LIST')
